import React, { PureComponent } from 'react';
import './styles.css';
import ViewCarouselPhotos from '../../../components/ViewCarouselPhotos';
import ViewCarouselVideos from '../../../components/ViewCarouselVideos';
import ViewCarousel360Images from '../../../components/ViewCarousel360Images';
import DealerProducts from '../../../components/DealerProducts';
import ImmersiveTourButton from '../../../components/ImmersiveTourButton';
import SocialShare from '../../../components/SocialShare';
import { isFSBOContact, getMediaVideos, getMediaImages, get360Photos } from '../../../utils/listingHelper';
import PropTypes from 'prop-types';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import LiveVideoTour from '../../../components/LiveVideoTour';
import classnames from 'classnames';
import messages from '../../../utils/translationMessages';
import { formatMessage as t } from '../../../utils/language';
// import { getImmersiveTour } from '../../../utils/immersiveTourHelper';
export class ButtonTray extends PureComponent {
  state = { shareOpen: false };
  handleShareToggle = (open) => {
    this.setState({ shareOpen: open });
  }
  render() {
    const { listing, productType, openVideoTourModal, onClickImmersiveTourButton,
      showImmersiveTour, handleOpenContactForm, breakpoint } = this.props;
    let firstRow = (
      <div className={classnames('details-button-tray row', { 'open': this.state.shareOpen })}>
        <SocialShare type="tray" listing={listing} productType={productType} handleShareToggle={this.handleShareToggle} handleOpenContactForm={handleOpenContactForm} breakpoint={breakpoint} openImmersiveTourModal={onClickImmersiveTourButton}/>
        <LiveVideoTour listingId={listing.id} openVideoTourModal={openVideoTourModal} />
      </div>
    );

    return (
      <div className={classnames('details-button-tray', { 'open': this.state.shareOpen })}>
        {openVideoTourModal ? firstRow : <SocialShare type="tray" listing={listing} productType={productType} handleShareToggle={this.handleShareToggle} handleOpenContactForm={handleOpenContactForm} breakpoint={breakpoint} openImmersiveTourModal={onClickImmersiveTourButton} /> }
        <div className="details-button-tray row second-row">
          {
            showImmersiveTour && <ImmersiveTourButton listing={listing}  onClick={onClickImmersiveTourButton}/>
          }
        </div>
      </div>
    );
  }
}
ButtonTray.propTypes = {
  /** Listing information of the boat */
  listing: listingPropTypes,
  productType: PropTypes.string,
  openVideoTourModal: PropTypes.func,
  onClickImmersiveTourButton: PropTypes.func,
  showImmersiveTour: PropTypes.bool,
  handleOpenContactForm: PropTypes.func,
  breakpoint: PropTypes.string
};

export class CarouselButtonTray extends PureComponent {
  state = { shareOpen: false };
  handleShareToggle = (open) => {
    this.setState({ shareOpen: open });
  }
  render() {
    const { listing, openCarouselModal, productType, openVideoTourModal,
      onClickImmersiveTourButton, showImmersiveTour, handleOpenContactForm,
      breakpoint, showManufacturerForm } = this.props;
    let videos = getMediaVideos(listing);
    let images = getMediaImages(listing);
    let images360 = get360Photos(listing);

    return (<div className="carousel-button-tray-wrapper">
      <div className="tray-contact-button">
        <button className="contact-button" onClick={handleOpenContactForm}>
          {showManufacturerForm ? t(messages.detailsManufacturer.findDealerButton) : t(messages.contactGroup.contact)}
        </button>
      </div>
      <div className="carousel-button-tray-right-bottom">
        {openVideoTourModal && <LiveVideoTour listingId={listing.id} openVideoTourModal={openVideoTourModal} />}
        {
          showImmersiveTour &&
          <ImmersiveTourButton carouselLayout  onClick={onClickImmersiveTourButton}/>
        }
        {!isFSBOContact(listing.contact) &&
          <DealerProducts carouselLayout listing={listing} productType={productType}/>
        }
      </div>
      <div className={classnames('carousel-button-tray', { 'open': this.state.shareOpen })}>
        <SocialShare type="overlay" listing={listing} productType={productType} handleShareToggle={this.handleShareToggle} handleOpenContactForm={handleOpenContactForm} breakpoint={breakpoint} openImmersiveTourModal={onClickImmersiveTourButton} />
      </div>
      <div className="carousel-button-tray-left-bottom">
        {videos.length > 0 &&
          <ViewCarouselVideos
            listingHasImages={images.length > 0}
            listing={listing}
            openCarouselModal={openCarouselModal}
          />}
        {images.length > 0 &&
          <ViewCarouselPhotos
            images={images}
            openCarouselModal={openCarouselModal}
          />}
        {images360.length > 0 &&
        <ViewCarousel360Images
          listingHasImages={images.length > 0}
          listingNumVideos={videos.length}
          listing={listing}
          openCarouselModal={openCarouselModal}/>}
      </div>
    </div>
    );
  }
}

CarouselButtonTray.propTypes = {
  /** string desktop, mobile or tablet */
  device: PropTypes.string,
  /** Listing information of the boat */
  listing: listingPropTypes,
  productType: PropTypes.string,
  /** Function to open the Carousel Modal when the buttons are clicked */
  openCarouselModal: PropTypes.func,
  openVideoTourModal: PropTypes.func,
  onClickImmersiveTourButton: PropTypes.func,
  showImmersiveTour: PropTypes.bool,
  handleOpenContactForm: PropTypes.func,
  breakpoint: PropTypes.string,
  showManufacturerForm: PropTypes.bool
};
